import * as MITO from '@zyf2e/monitor-web'
import { getCookie, getUser } from './index'
import Device from '@skillnull/device-js'
import Vrouter from '@/router'

const ignoreErrors = ['ResizeObserver loop limit exceeded'] //忽略错误

//寻找数据
const getData = (data, key) => {
  const listData = key.split('.')
  function findChildData(datas) {
    const first = listData.shift()
    return listData.length
      ? findChildData(datas[first] || {})
      : datas[first] || ''
  }
  return findChildData(data)
}

export default (app, keyName) => {
  const apikey = keyName
  app.use(MITO.MitoVue)
  MITO.init({
    dsn: `${process.env.VUE_APP_FONT}/api/reportActive`,
    apikey,
    configReportXhr(xhr) {
      xhr.setRequestHeader('X-ZYLX-TOKEN', getCookie('X-ZYLX-TOKEN'))
      const devData = getCookie('dev')
      if (devData) xhr.setRequestHeader('dev', devData)
    },
    async beforeDataReport(event) {
      const {
        data: { userName, fullName, schoolId, token }
      } = await getUser()
      const { data } = event
      const dev = getCookie('dev')
      //获取用户信息
      data.userInfo = {
        userName,
        fullName,
        schoolId,
        token,
        dev
      }

      const routeData = getData(Vrouter, 'app._route.meta.title')
      data.pageTitle = apikey + '-' + routeData //页面title

      data.device = await Device.Info({
        info: ['OS', 'OSVersion', 'deviceType', 'netWork', 'browserInfo']
      }).then(data => data) //获取设备信息

      //忽略报错
      if (ignoreErrors.includes(data.message)) return false

      //不带端口则报送
      if (!/:\d+/.test(data.url)) return data

      // 注意:判断是否调用dsn还是trackDsn的规则
      // (event.data.actionType === undefined || !event.data.isTrackData) 为true那么认为此次上报的类型是错误上报，否则是埋点上报
    }
  })
}
